//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

const PREFIX = 'tiktok-like2buy-moderation-';

export const TikTokLike2BuyTrackingIds = {
  ADD_MEDIA_BUTTON: `${PREFIX}add-media-button`,
  ARCHIVE_ACTION_BUTTON: `${PREFIX}archive-action-button`,
  ARCHIVE_BULK_ACTION_BUTTON: `${PREFIX}archive-bulk-action-button`,
  CUSTOMIZATIONS_MODAL: `${PREFIX}customizations-modal`,
  CUSTOMIZATIONS_MODAL_BANNER_ALT_TEXT: `${PREFIX}customizations-modal-banner-alt-text`,
  CUSTOMIZATIONS_MODAL_BANNER_EXPANDABLE: `${PREFIX}customizations-modal-banner-expandable`,
  CUSTOMIZATIONS_MODAL_BANNER_DESTINATION_URL: `${PREFIX}customizations-modal-banner-url`,
  CUSTOMIZATIONS_MODAL_BANNER_IMAGE_UPLOAD: `${PREFIX}customizations-modal-banner-image-upload`,
  CUSTOMIZATIONS_MODAL_CANCEL_BUTTON: `${PREFIX}customizations-modal-cancel-button`,
  CUSTOMIZATIONS_MODAL_CTAS_EXPANDABLE: `${PREFIX}customizations-modal-ctas-expandable`,
  CUSTOMIZATIONS_MODAL_CTAS_GALLERY_HEADER_CTA: `${PREFIX}customizations-modal-ctas-gallery-header-cta`,
  CUSTOMIZATIONS_MODAL_CTAS_GALLERY_MEDIA_HOVER_CTA: `${PREFIX}customizations-modal-ctas-gallery-media-hover-cta`,
  CUSTOMIZATIONS_MODAL_CTAS_PRODUCTS_CONTAINER_CTA: `${PREFIX}customizations-modal-ctas-products-container-cta`,
  CUSTOMIZATIONS_MODAL_EMAIL_CAPTURE_CTA: `${PREFIX}customizations-modal-email-capture-cta`,
  CUSTOMIZATIONS_MODAL_EMAIL_CAPTURE_EXPANDABLE: `${PREFIX}customizations-modal-email-capture-expandable`,
  CUSTOMIZATIONS_MODAL_EMAIL_CAPTURE_TERMS_AND_CONDITIONS_REQUIRED: `${PREFIX}customizations-modal-email-capture-terms-and-conditions-required`,
  CUSTOMIZATIONS_MODAL_EMAIL_CAPTURE_TERMS_AND_CONDITIONS_URL: `${PREFIX}customizations-modal-email-capture-terms-and-conditions-url`,
  CUSTOMIZATIONS_MODAL_SAVE_BUTTON: `${PREFIX}customizations-modal-save-button`,
  CUSTOMIZATIONS_MODAL_PREVIEW_BUTTON: `${PREFIX}customizations-modal-preview-button`,
  CUSTOMIZATIONS_PREVIEW_MODAL: `${PREFIX}customizations-preview-modal`,
  HEADER_CUSTOMIZE_STORE_BUTTON: `${PREFIX}header-customize-store-button`,
  PIN_TO_TOP_ACTION_BUTTON: `${PREFIX}pin-to-top-action-button`,
  PIN_TO_TOP_BULK_ACTION_BUTTON: `${PREFIX}pin-to-top-bulk-action-button`,
  PINNED_MEDIA_SECTION_HEADER: `${PREFIX}pinned-media-section-header`,
  PINNED_MEDIA_SECTION_TOGGLE: `${PREFIX}pinned-media-section-toggle`,
  PREVIEW_BUTTON: `${PREFIX}preview-button`,
  REQUEST_RIGHTS_BUTTON: `${PREFIX}request-rights-button`,
  STATUS_FILTER_SELECT: `${PREFIX}status-filter-select`,
  TAG_PRODUCTS_BUTTON: `${PREFIX}tag-products-button`,
} as const;
